var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-container" },
    [
      _c("v-select", {
        staticClass: "form-control",
        attrs: {
          reduce: _vm.reduceSelectedOption,
          value: _vm.value,
          options: _vm.options,
          clearable: false,
          multiple: _vm.isMulti,
          autocomplete: "",
          disabled: !_vm.canEdit
        },
        on: { input: _vm.setQuestionValue }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }